/** "<vendor> - <ship-to>" for a logistic preview title; a missing side drops out with its
 * separator (`code-rule.md` → "Composed display strings": `' - '`, not an arrow). */
export const buildLogisticRouteLabel = (vendorName?: string, shipToName?: string): string =>
  [vendorName, shipToName].filter(Boolean).join(' - ')
